import React from 'react';
import { contact } from '../data/contact';
export function Footer() {
  return <footer className="w-full border-t border-sand-200 bg-sand-50 py-10" data-id="element-44" data-mp="3gezcj1s77n03">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-4 px-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-45" data-mp="3ghc486nrdbqc">
        <div data-id="element-46" data-mp="36p6df098t0cq">
          <p className="font-display text-lg text-ink" data-id="element-47" data-mp="36oy0j8d4dv1j">
            Passion Rénovation <span className="text-ink-muted" data-id="element-48" data-mp="3uf0opddwyguv">— {contact.name}</span>
          </p>
          <p className="mt-1 text-sm text-ink-muted" data-id="element-49" data-mp="3ucxnryb833bd">
            Peinture · Finitions · Vitrerie · Rénovation de logements
          </p>
        </div>
        <div className="flex flex-col gap-1 text-sm text-ink-soft sm:items-end" data-id="element-50" data-mp="3lf57aqtrlpme">
          <a href={contact.phoneHref} className="transition-colors duration-150 ease-out hover:text-brique" data-id="element-51" data-mp="3qcxbokblj47h">
            {contact.phoneLabel}
          </a>
          <a href={`mailto:${contact.email}`} className="transition-colors duration-150 ease-out hover:text-brique" data-id="element-52" data-mp="29xvqkc20tbos">
            {contact.email}
          </a>
        </div>
      </div>
    </footer>;
}